import React from 'react';

const RenderField = ({ field, fieldState, label, type, placeholder, t }) => {
  const { error, isTouched } = fieldState;
  
  return (
    <div className="form-group">
      <label className="label" htmlFor={field.name}>{label}</label>
      <input
        {...field}
        placeholder={placeholder}
        type={type}
        id={field.name}
        className={`form-control ${isTouched && error ? 'form-control--has-error' : ''} ${!error && isTouched ? 'form-control--has-success' : ''}`}
      />
      {isTouched && error && (
        <span className="help-text help-text--has-error">
          {!error.message.includes(" ") ? t(`findDelivery.validateForm.${error.message}`) : error.message}
        </span>
      )}
    </div>
  );
};

export default RenderField;
